import { DrawerProps } from '@silverfort/sf-components';
import React, { createContext, useState, useContext, ReactNode, useMemo } from 'react';

interface AppDrawerContextType {
    appDrawerProps: DrawerProps | undefined;
    setAppDrawerProps: (props: DrawerProps) => void;
    openAppDrawer: () => void;
    closeAppDrawer: () => void;
    displayContent: (content: ReactNode) => void;
    updateAppDrawerProps: (props: DrawerProps) => void;
}

export const AppDrawerContext = createContext<AppDrawerContextType | undefined>(undefined);

export const AppDrawerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [appDrawerProps, setAppDrawerProps] = useState<DrawerProps | undefined>();

    const value = useMemo(
        () => ({
            appDrawerProps,
            setAppDrawerProps,
            openAppDrawer: () => setAppDrawerProps({ ...appDrawerProps, open: true }),
            closeAppDrawer: () => setAppDrawerProps({ ...appDrawerProps, open: false }),
            displayContent: (content: ReactNode) =>
                setAppDrawerProps({ ...appDrawerProps, children: content, open: true }),
            updateAppDrawerProps: (props: DrawerProps) => setAppDrawerProps({ ...appDrawerProps, ...props })
        }),
        [appDrawerProps]
    );

    return <AppDrawerContext.Provider value={value}>{children}</AppDrawerContext.Provider>;
};

export const useAppDrawer = () => {
    const context = useContext(AppDrawerContext);
    if (!context) {
        throw new Error('useAppDrawer must be used within a AppDrawerProvider');
    }
    return context;
};
